
import { useEffect } from 'react';
import { useTour } from '@reactour/tour';

export const useWalkthrough = () => {
  const { setIsOpen, isOpen } = useTour();

  const startWalkthrough = () => {
    setIsOpen(true);
  };

  const checkFirstVisit = () => {
    const hasCompletedWalkthrough = localStorage.getItem('walkthrough-completed');
    if (!hasCompletedWalkthrough) {
      // Delay para garantir que os elementos estejam renderizados
      setTimeout(() => {
      //   startWalkthrough();
      }, 1000);
    }
  };

  return {
    startWalkthrough,
    checkFirstVisit,
    isOpen,
  };
};
